module.exports = __webpack_public_path__ + "static/media/Screen Shot 2023-02-20 at 12.27.00.a818eecd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screen Shot 2023-02-20 at 12.27.00.png
// module id = 1241
// module chunks = 1